/**
 * Diese Klasse ist dafür da, um Anfragen aus dem Frontend an das Backend weiterzuleiten
 */
import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import {User} from '../model/user.class';
import {AuthHttp} from 'angular2-jwt';
import {Router} from '@angular/router';


import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import {BSModalContext, Modal} from 'angular2-modal/plugins/bootstrap';
import {Observable} from 'rxjs/Observable';
import {Publisher} from '../model/publisher.class';
import {Media} from '../model/media.class';
import {FileUploader} from 'ng2-file-upload';
import {MediaElement} from '../model/mediaElement.class';
import {Version} from '../model/version.class';
import {MediaModal} from './media.modal';
import {overlayConfigFactory} from 'angular2-modal';
import {VersionDetailComponent} from '../versionDetail/version.detail.component';
import {VersionNewComponent} from '../versionNew/version.new.component';

@Injectable()
export class UserService {

    // Konstanten
    public static readonly baseUrl = 'api/';
    public static streamingServerUrl = 'http://bookii-streamingservice.de/files/';
    public readonly Admin = 'Administrator';
    public readonly SuperUser = 'Privilegiert';
    public readonly User = 'Normal';
    public readonly None = 'Gesperrt';
    public readonly New = 'Neu';
    public readonly Approved = 'Freigegeben';
    public readonly Unready = 'Unfertig';
    public readonly userType = [this.Admin, this.SuperUser, this.User, this.None];
    public readonly mediaStatus = [this.New, this.Approved, this.None];

    public videoUploader: FileUploader = new FileUploader({});
    public uploader: FileUploader = new FileUploader({});
    public kiiUploader: FileUploader = new FileUploader({});
    public storyboardUploader: FileUploader = new FileUploader({});
    public zipUploader: FileUploader = new FileUploader({});

    public user: User;
    public statusMessage = '';


    private loggedIn: Boolean = false;
    private loginUrl = UserService.baseUrl.concat('login');


    constructor(private router: Router, private authHttp: AuthHttp, private Http: Http, public modal: Modal) {
        this.loggedIn = !!localStorage.getItem('token');
        if (!window.location.href.startsWith('https://www.bookii-medienservice')) {
            UserService.streamingServerUrl = 'http://testserver.bookii-streamingservice.de/files/';
        }

    }

    login(mail, password) {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        this.Http.post(
            this.loginUrl, JSON.stringify({ 'mail': mail, 'password': password }), { headers })
            .map(res => res.json()).subscribe(
                (data) => {
                    localStorage.setItem('token', data.jwt);
                    this.user = data.user as User;
                    this.loggedIn = true;
                    this.statusMessage = '';
                    switch (this.user.userType) {
                        case this.Admin:
                            this.router.navigate(['/publisher/list']);
                            break;
                        case this.SuperUser:
                            this.router.navigate(['/publisher/detail', this.user.publisher.publisherId]);
                            break;
                        case this.User:
                            this.router.navigate(['/publisher/detail', this.user.publisher.publisherId]);
                            break;
                        default:
                            this.statusMessage = 'User gesperrt';
                            this.logout();
                    }
                },
            () => {
                this.statusMessage = 'Falsche Eingabeparameter';
            });
    }

    logout() {
        localStorage.removeItem('token');
        this.loggedIn = false;
        this.user = null;
        this.router.navigate(['/']);
    }

    getServerInfo(parameter: string): Observable<any> {
        const url = UserService.baseUrl.concat(parameter);
        return this.Http.get(url).map(response => response.text());
    }

    getAdminPublisher(): Observable<Publisher> {
        const publisherUrl = UserService.baseUrl.concat('publisher/admin');
        return this.authHttp.get(publisherUrl).map(response => response.json()).map(
            (data) => {
                return data as Publisher;
            }
        );
    }

    getPublishersWithout(publisherId: number): Observable<Publisher[]> {
        const publishersUrl = UserService.baseUrl.concat('publisher/without/').concat(String(publisherId));
        return this.authHttp.get(publishersUrl).map(response => response.json()).map(
            (data) => {
                return data as Publisher[];
            }
        );
    }

    // Zustaedig für get-Anfragen, die nur ein bestimmtes Element zurückliefern sollen
    get(id: number, name: string): Observable<Object> {
        const userUrl = UserService.baseUrl.concat(name + '/').concat(String(id));
        return this.authHttp.get(userUrl).map(response => response.json()).map(
            (data) => {
                return data as Object;
            }
        );
    }

    // Get request to any URL
    getByUrl(url: string): Observable<Object> {
        return this.authHttp.get(UserService.baseUrl + url).map(response => response.json()).map(
            (data) => {
                return data as Object;
            }
        );
    }

    getPenStats(mid: number): Observable<Object> {
        const userUrl = UserService.baseUrl.concat('media/' + mid + '/penStats');
        return this.Http.get(userUrl).map(response => response.json()).map(
            (data) => {
                return data as Object;
            }
        );
    }

    // Zustaendig für get-Anfragen, die alle Elemente zurückliefern sollen
    getAll(name: string): Observable<Object[]> {
        const url = UserService.baseUrl.concat(name);
        return this.authHttp.get(url).map(response => response.json()).map(
            (data) => {
                return data as Object[];
            }
        );
    }

    // Zustaendig für get-Anfragen, die alle Elemente eines bestimmten übergeordneten Elements zurückliefern sollen
    // z.B. allle Organisationseinheiten einer bestimmten Version
    getBy(name: string, byId: number, byName: string): Observable<Object[]> {
        const publisherUsersUrl = UserService.baseUrl.concat(byName + '/' + byId + '/' + name);
        return this.authHttp.get(publisherUsersUrl).map(response => response.json()).map(
            (data) => {
                return data as Object[];
            }
        );
    }

    getStats(id: number, name: string): Observable<any> {
        const url = UserService.baseUrl.concat(name + '/' + id + '/stats');
        return this.authHttp.get(url).map(response => response.json()).map(
            (data) => {
                return data as any;
            }
        );
    }

    checkMail(mail: String): Observable<Boolean> {
        const checkMailUrl = UserService.baseUrl.concat('check');
        return this.authHttp.post(checkMailUrl, mail).map(response => response.json()).map(
            (data) => {
                return data as Boolean;
            }
        );
    }

    update(object: Object, name: string): Observable<Object> {
        const url = UserService.baseUrl.concat(name);
        return this.authHttp.put(url, object)
            .map(response => response.json());
    }

    delete(id: number, name: string): Observable<any> {
        const url = UserService.baseUrl.concat(name + '/').concat(String(id));
        return this.authHttp.delete(url)
            .map(response => response.json());
    }

    // FÜR BLACKLISTS
    deleteAllBlacklists(name: string): Observable<any> {
        const url = UserService.baseUrl.concat(name);
        return this.authHttp.delete(url)
            .map(response => response.json());
    }

    getBlacklistByName(name: string, blacklistName: string): Observable<Object> {
        const url = UserService.baseUrl.concat(name + '/').concat(blacklistName);
        return this.authHttp.get(url)
            .map(response => response.json()).map(
                (data) => {
                    return data as Object;
                }
            );
    }







    deleteVideo(publisherId: number, mid: number, videoName: string): Observable<any> {
        const url = UserService.baseUrl.concat('files/' + publisherId + '/' + mid + '/' + videoName);
        return this.authHttp.delete(url);
    }

    create(object: Object, name: string): Observable<Object> {
        const url = UserService.baseUrl.concat(name);
        return this.authHttp.post(url, object)
            .map(response => response.json());
    }

    publish(version: number): Observable<any> {
        const url = UserService.baseUrl.concat('version/' + version + '/publish');
        return this.authHttp.get(url);
    }

    syncStreaming(): Observable<any> {
        const url = UserService.baseUrl.concat('syncStreamingServer');
        return this.authHttp.get(url);
    }

    uploadCover(media: Media): Observable<any> {
        const URL = UserService.baseUrl.concat('files/' + media.publisher.publisherId + '/' + media.mid);
        this.uploader.setOptions({ url: URL, authToken: 'Bearer ' + localStorage.getItem('token') });
        this.uploader.uploadAll();
        const element: MediaElement = new MediaElement(media.mid + '_' + media.bookAreaCode + '.png', 'Cover', media);
        return this.create(element, 'mediaElement');
    }

    uploadKii(comment: string, media: Media, version: number, status: string, instance: VersionNewComponent): void {
        const URL = UserService.baseUrl.concat('files/' + media.publisher.publisherId + '/' + media.mid + '/' + version);
        this.kiiUploader.setOptions({ url: URL, authToken: 'Bearer ' + localStorage.getItem('token') });
        const userService: UserService = this;
        let error = false;
        instance.message = 'Upload läuft, das kann je nach Dateigröße ein paar Sekunden bis zu einigen Minuten dauern.';

        this.kiiUploader.onCompleteItem = (item: any, response: any,) => {
            if (response === 'false') {
                instance.message = 'Hochladen der Datei ist fehlgeschlagen!';
                error = true;
            } else {
                instance.message = item.file.name + ' wurde erfoglreich hochgeladen';
            }
        };

        this.kiiUploader.onCompleteAll = function () {
            if (!error) {
                const element: Version = new Version(version, null, media, comment, status, null, true);
                userService.create(element, 'version').subscribe();
            }
        };
        this.kiiUploader.uploadAll();
    }

    uploadStoryboard(versionId: number) {
        const URL = UserService.baseUrl.concat('version/' + versionId + '/storyboard');
        //    var options: FileUploaderOptions = {};
        //    options.headers = [{ name: 'Content-Type', value: 'text/plain; charset=UTF-8'}];
        //    this.storyboardUploader.setOptions(options);
        this.storyboardUploader.setOptions({ url: URL, authToken: 'Bearer ' + localStorage.getItem('token') });
        this.storyboardUploader.uploadAll();
    }

    uploadMedias(versionId: number, instance: VersionDetailComponent) {
        const component = this;
        const URL = UserService.baseUrl.concat('version/' + versionId + '/medias');
        this.zipUploader.setOptions({ url: URL, authToken: 'Bearer ' + localStorage.getItem('token') });
        this.zipUploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
            console.log(response);
            if (response === 'true') {
                const subComponent = component;
                component.zipUploader.clearQueue();
                component.authHttp.get(URL).map(getResponse => getResponse.json()).subscribe(
                    (data) => {
                        subComponent.modal.open(MediaModal, overlayConfigFactory({
                            newAudioFiles: data.newAudioFiles,
                            newVideoFiles: data.newVideoFiles,
                            overwritenAudioFiles: data.overwritenAudioFiles,
                            overwritenVideoFiles: data.overwritenVideoFiles,
                            wrongFilesCount: data.wrongFilesCount,
                            wrongFilesNames: data.wrongFilesNames
                        }, BSModalContext));
                        subComponent.authHttp.delete(URL).map(deleteResponse => deleteResponse.json()).subscribe();
                        instance.mediaUploadSuccessful = true;
                        instance.message = '';
                    },
                    (err) => instance.message = 'Probleme beim Kopieren des ZIP-Archivs'
                );
            } else {
                instance.message = 'Probleme beim Kopieren des ZIP-Archivs';
            }

        };
        this.zipUploader.uploadAll();
    }

    getGrafic(organisationUnitId: number): Observable<any> {
        const url = UserService.baseUrl.concat('showGrafic/' + organisationUnitId);
        return this.authHttp.get(url).map(response => response.json()).map(
            (data) => {
                return data as any;
            }
        );
    }

    openMrge(media: Media): void {
        const url = UserService.baseUrl.concat('mrge/media/' + media.mediaId + '/version/new');
        this.authHttp.get(url).subscribe();
    }

    downloadSpeaker(name: string) {
        const url = UserService.baseUrl.concat(name);
        this.authHttp.get(url);
    }

    determineImageUrl(media: Media) {
        if (!window.location.href.startsWith('https://www.bookii-medienservice')) {
            UserService.streamingServerUrl = 'http://testserver.bookii-streamingservice.de/files/';
        }
        const publisherId = media.publisher.publisherId;
        const mid = media.mid;
        const areaCode = media.bookAreaCode;
        return UserService.streamingServerUrl + publisherId + '/' + mid + '/' + mid + '_' + areaCode + '.png';
    }
}




// WEBPACK FOOTER //
// ./src/app/services/user.service.ts